export default __webpack_public_path__ + "static/media/body-work-accept.f7eaee14.png";